import { styled } from '@mui/material/styles';

export const RadarAxesLine = styled('line')(({ theme }) => ({
  strokeWidth: 0.5,
  // opacity: 0.2,
  opacity: 0.5,
  stroke: theme.palette.primary.light,
}));
